


































import { mapGetters, mapActions } from 'vuex'
import MainNavbar from '@/components/MainNavbar.vue'

export default {
  name: 'RiskAssessmentReview',
  components: {
    MainNavbar
  },
  data () {
    return {
      assessment: null,
      submission: null,
      selections: [],
      selected: 0
    }
  },
  computed: {
    ...mapGetters([
      'sessionUser',
      'sessionUserHomePage',
      'riskLevels',
      'riskLevelClasses',
      'currentQuarter',
      'currentYear'
    ]),
    riskQuestions () {
      return (this.assessment) ? this.assessment.questions : []
    },
    feedback () {
      const feedback = []
      let a: number
      for (let q=0; q<this.riskQuestions.length; q++) {
        if (!(typeof this.selections[q] === 'undefined' || this.selections[q] === null)) {
          a = this.selections[q]
          feedback.push(this.riskQuestions[q].options[a].feedback)
        } else {
          feedback.push('')
        }
      }
      return feedback
    },
    formIncomplete () {
      // return this.selections.reduce((prev, cur) => {return (prev !== null && cur !== null)})
      if (this.selections.length === 0) return true
      for (let s in this.selections) {
        if (this.selections[s] === null) return true
      }
      return false
    },
  },
  methods: {
    ...mapActions([
      'getAssessmentSubmission'
    ]),
    chooseAnswer (q: number, a: number) {
      console.log('RiskAssessmentPage.chooseAnswer', q, a)
      this.$set(this.selections, q, a)
      console.log(this.selections)
    },
  },
  async mounted () {
    console.log('RiskAssessmentReview.mounted')
    let result: any
    if (this.$route.params.hasOwnProperty('subId')) {
      result = await this.getAssessmentSubmission(this.$route.params.subId)
      if (result.success) {
        this.assessment = result.data.assessment
        this.submission = result.data.submission
        this.selections = JSON.parse(JSON.stringify(this.submission.answers))
      }
    }
  },
}
